
import axios from "axios";
import { store } from "store";
import { OutputBaseProps, PaginationProps } from "utils/types/API";
import { WorkflowItemProps } from ".";
import { loading, index, options } from "store/workflow";

interface ApiWorkflowInputProps {
    page?: number;
    pageSize?: number;
    q?: string;
}

type ApiWorkflowOutputProps = OutputBaseProps<{ list: WorkflowItemProps[]; pagination?: PaginationProps; }>

export const apiWorkflowIndex = async (data: ApiWorkflowInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiWorkflowOutputProps>("/api/workflows", { params: data }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(index({ data: res.data.list, pagination: res.data.pagination }));
    }
    return res;
};

export const apiWorkflowOptions = async (data: { q?: string; }) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiWorkflowOutputProps>("/api/workflows", { params: { ...data, fields: "id,code,name,sort" } }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(options({ data: res.data.list }));
    }
    return res;
};